'use client';

import * as React from 'react';
import * as FramerMotion from 'framer-motion';

// Re-export the motion object with all its properties
export const motion = FramerMotion.motion;

// Export AnimatePresence directly from framer-motion
export const AnimatePresence = FramerMotion.AnimatePresence;

// Export basic motion components with proper typing
export const MotionDiv = React.forwardRef<HTMLDivElement, FramerMotion.HTMLMotionProps<"div">>(function MotionDiv(props, ref) {
  return <motion.div ref={ref} {...props} />;
});

export const MotionSection = motion.section;
export const MotionUl = motion.ul;
export const MotionLi = motion.li;
export const MotionSpan = motion.span;
export const MotionH1 = motion.h1;
export const MotionH2 = motion.h2;
export const MotionH3 = motion.h3;
export const MotionP = motion.p;

// Export AnimatePresence wrapper
interface SafeAnimatePresenceProps {
  children: React.ReactNode;
  mode?: "sync" | "wait" | "popLayout";
  initial?: boolean;
  onExitComplete?: () => void;
}

export function SafeAnimatePresence({ children, ...props }: SafeAnimatePresenceProps) {
  return (
    <AnimatePresence {...props}>
      {children}
    </AnimatePresence>
  );
}

// Export types
export interface MotionProps extends FramerMotion.HTMLMotionProps<"div"> {
  children: React.ReactNode;
}

MotionDiv.displayName = 'MotionDiv';